import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import styles from './TooltipWrapper.scss';

const TooltipWrapper = ({ children, className, id, message, trigger, show }) => {
  return (
    <OverlayTrigger
      overlay={(props) => (
        <Tooltip
          {...props}
          arrowProps={{ style: { display: 'none' } }}
          className={`${styles['tooltip-wrapper']}${!!className ? ` ${className}` : ''}`}
          id={id}>
          {message}
        </Tooltip>
      )}
      trigger={trigger}
      show={show}>
      {children}
    </OverlayTrigger>
  );
};

export default TooltipWrapper;
